import {Component} from "@angular/core";
import {RouteConfig, RouteDefinition} from "@angular/router-deprecated";
import {HttpComponent} from "./http/component";
import {BlankComponent} from "../shared/blank/component";

const ROUTES: Array<{ name: string; component: any }> = [
  { component: HttpComponent, name: "Http" },
];

@Component({
  selector: "http-root",
  template: `
<module-root name="Http" [routes]="routes"></module-root>
  `
})
@RouteConfig(
  ROUTES.map<RouteDefinition>(route => {
    return <RouteDefinition>{
      path: `/${route.name.toLowerCase()}`,
      component: route.component,
      name: route.name,
    };
  }).concat({ path: "/", component: BlankComponent, useAsDefault: true })
)
export class HttpRoot {
  private routes = ROUTES;
}



/** WEBPACK FOOTER **
 ** ./script/http/root.component.ts
 **/